document.addEventListener('DOMContentLoaded', () => {
  const bestSwiper = () => {
    new Swiper('.best-seller__slider', {
      spaceBetween: 4,
      slidesPerView: 1.3,
      watchOverflow: true,
      loop: true,
      breakpoints: {
        2000: {
          slidesPerView: 6.2
        },
        1700: {
          slidesPerView: 5.2
        },
        1130: {
          slidesPerView: 4.2
        },
        992: {
          slidesPerView: 3.2
        },
        768: {
          slidesPerView: 3.2
        },
        478: {
          slidesPerView: 2.2
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  };

  document.addEventListener('shopify:section:load', () => {
    bestSwiper();
  });

  bestSwiper();
});